<template>
    <div class="container my-3 w-50 cardRegister container px-2 py-2 border border-secondary-subtle">
        <h2 class="mt-3 mb-3">Registro</h2>
        <RegisterForm></RegisterForm>
    </div>
</template>

<script>
import RegisterForm from "@/components/Login/RegisterFormComponent.vue";

export default {
    data() {
        return {

        }
    },
    components: {
        RegisterForm,
    },
}
</script>